import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(props) => (props.loading === 1 ? 'inherit' : 'center')};
  @media (max-width: 768px) {
    flex-direction: column;
    width: calc(100vw - 20px) !important;
    align-items: center !important;
  }
`;

export const Graph = styled.div`
  display: flex;
  flex-direction: column;
  h6 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #828282;
    text-align: center;
    margin-bottom: 28px;
  }
  /* box-shadow: rgba(0,0,0,0.1) 0px 0px 2px 2px; */
  margin-right: 5px;
  padding-bottom: 10px;
`;


export const SubContainer = styled.div`
  margin: 5px;
  padding: 5px;
  background-color: white;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
  width: calc(100vw - 90px);
  box-shadow: -1px 1px 5px 1px rgba(0, 0, 0, 0.1);
  @media (max-width: 768px) {
    flex-direction: column;
    width: calc(100vw - 20px) !important;
  }
`;

export const SubContainerTitle = styled.h4`
  font-size: 1rem;
  font-weight: 700;
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
  text-align: left;
  /* width: 100%; */
  margin-left: 20px;
`;

export const Indicator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  padding: 0px 10px 0px 10px;
  /* border-right: 1px solid #ccc; */
  flex-wrap: wrap;
  min-width: 150px;
  max-width: 150px;
  min-height: 100px;
  margin-bottom: 10px;
  font-size: 0.9rem;
  color: #6c6c6c;
  cursor: pointer;
  border-radius: 1rem;
  margin-right: 5px;
  padding-bottom: 5px;
  font-weight: 600;
  h6 {
    font-weight: 700;
    font-size: 0.9rem;
    font-weight: 800;
    color: #61098a;
  }
  p {
    font-size: 0.9rem;
    font-weight: 700;
    color: #6c6c6c;
  }
  :hover {
    background: linear-gradient(to right, #e6e3e44d, #9b9b9b4d);
  }
  background: ${(props) =>
    props.selected === true
      ? 'linear-gradient(to right,#e6e3e44d,#9b9b9b4d);'
      : 'linear-gradient(to right,#e6e3e41a,#9b9b9b1a)'};
`;


export const IndicatorsLine = styled.div`
  margin-left: 1%;
  padding: 10px;
  flex-wrap: wrap;
  display: flex;
  flex-direction: ${(props) => (props.loading === 1 ? 'column' : 'row')};
  margin-top: 5px;
  margin-bottom: 10px;
  width: 99%;
  font-size: 0.9rem;
  @media (max-width: 768px) {
    display: ${(props) => (props.loading === 1 ? 'none' : 'flex')};
    padding: 0px;
    table{
      max-width: calc(100vw - 45px)!important;
    }
  }
  justify-content: flex-start;
  #indicator:hover {
    background-color: unset!important;
    color: unset!important;
    cursor: pointer!important;
    /* font-weight: 900!important;     */
  }
  #product {
    font-size: 0.9rem;
  }
  #indicator{
    padding-right: 5px!important;
    font-size: 0.9rem;
  }
  tr:hover{
    color: #bd207b;
  }
  td{
    padding-right: 5px!important;    
  }

  @media all {
  .page-break {
    display: none;
  }
}
 
@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}
 
@media print {
  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: auto;
  }
}


`;


export const DivDetalhe = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;


export const Linha = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Labels = styled.label`
  font-size: ${(props) =>
    props.fontSize === undefined ? '1rem' : props.fontSize};
  color: ${(props) => (props.color === undefined ? '#858585' : props.color)};
  font-weight: ${(props) =>
    props.fontWeight === undefined ? '700' : props.fontWeight};
`;
